import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SHARED_ENV } from '../tokens';
import { NetworkHelper } from '../helpers';

@Injectable()
export class UploaderService {
  private readonly env = inject(SHARED_ENV);
  private readonly hostUrl: string;

  constructor(private networkHelper: NetworkHelper) {
    this.hostUrl = this.env.uploadHostUrl;
  }

  upload(file: File, currDir?: string, name?: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    if (currDir) {
      formData.append('currDir', currDir);
    }
    if (name) {
      formData.append('fileName', name);
    }
    return this.networkHelper.post(
      `${this.hostUrl}/uploader/upload/`,
      formData
    );
  }

  uploadAnnouncements(file: File): Observable<any> {
    return this.upload(file, 'announcements');
  }

  uploadVotingCurrency(file: File): Observable<any> {
    return this.upload(file, 'voting');
  }

  resolve(currDir?: string, relPath?: string): Observable<any> {
    const query = {
      currDir: '',
      relPath: '',
    };

    if (currDir) {
      query.currDir = currDir;
    }
    if (relPath) {
      query.relPath = relPath;
    }

    return this.networkHelper.get(`${this.hostUrl}/uploader`, query);
  }

  createDir(currDir: string, newDirName: string): Observable<any> {
    const body = {
      currDir,
      newDirName,
    };

    return this.networkHelper.post(`${this.hostUrl}/uploader/create`, body);
  }

  deleteDirOrFile(
    currDir: string,
    deleteDirOrFileName: string
  ): Observable<any> {
    const body = {
      currDir,
      deleteDirOrFileName,
    };
    return this.networkHelper.post(`${this.hostUrl}/uploader/delete`, body);
  }
}
